import {observable, action, runInAction} from 'mobx'
import {json} from "../../../../utils/ajax";
import {handleSearchAndPage, setStore, ValueObjToObj} from "../../../../utils/Utils";
import moment from "moment";

class hoursManualFolderStore {
    @observable list //表格数据
    @observable pagination //表格分页
    @observable searchField //表单搜索绑值
    constructor() {
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.searchField = {
            uploadName: '', // 上传文件名
            rangePicker:[]
        }
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields, fields) => {
        const change = ValueObjToObj(changedFields)
        this[fields] = {...this[fields], ...change}
    }

    /***列表数据 ***/
    @action
    initFolderPage = async (page) => {
        this.loading=true
        const rangePicker=this.searchField.rangePicker
        let searchField = {
            ...this.searchField,
            startTime: rangePicker &&  rangePicker.length === 0 ?  '' : moment(rangePicker[0]).format("YYYY-MM-DD") ,
            endTime:  rangePicker && rangePicker.length === 0 ?  '' : moment(rangePicker[1]).format("YYYY-MM-DD")
        }
        let search = handleSearchAndPage(page, this.pagination, searchField)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManualFolder/getFolderPage:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading=false
        })
    }

    /***重置**/
    @action
    handleReset = () => {
        this.searchField = {
            uploadName: '',
            rangePicker:[]
        }
        this.initFolderPage()
    }

}

export default new hoursManualFolderStore()



// WEBPACK FOOTER //
// ./src/project/dongfeng/toolTimeManual/ToolTimeFolder/store.js